import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { RiskFormulaFilter } from '../../../models/risk-formula-filter';
import { PageRequest } from '../../../models/page-request';
import { RiskFormula } from '../../../models/risk-formula';
import { AgilityRiskService } from '../../../providers/agility-risk.service';
import { AgilityRiskSpinnerService } from '../../../providers/agility-risk-spinner.service';
import { AgilityRiskDateTimeService } from '../../../providers/agility-risk-datetime.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/internal/operators/filter';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { ConfirmationModalComponent } from '../../shared/modals/confirmation-modal/confirmation-modal.component';
import { FORMULA_LIST_COLDEF } from '../config/list-table.config';
import { EntityType } from '../../../models/entity-type';
import { RiskFormulaStatus } from '../../../models/risk-formula-status';
import { AgilityRiskMessageService } from '../../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-formula-list',
  templateUrl: './risk-formula-list.component.html',
  styleUrls: ['./risk-formula-list.component.scss']
})
export class RiskFormulaListComponent implements OnInit {
  @Output() selectedFormulaChange = new EventEmitter<RiskFormula>();
  @Output() formulaUnselected = new EventEmitter<void>();
  @Output() createFormula = new EventEmitter<void>();
  @Input() addEditFormula!: boolean;
  @Input() selectedFormula!: RiskFormula;

  formulaListCols = FORMULA_LIST_COLDEF;
  formulaList: RiskFormula[] = [];

  constructor(
    private agilityRiskService: AgilityRiskService,
    public translateService: TranslateService,
    private dialogService: DialogService,
    private spinner: AgilityRiskSpinnerService,
    private dateTimeService: AgilityRiskDateTimeService,
    private messageService: AgilityRiskMessageService
  ) { }

  ngOnInit(): void {
    this.fetchRiskFormulas();
  }

  fetchRiskFormulas(): void {
    this.spinner.start();

    this.agilityRiskService.getRiskFormulas(new PageRequest<RiskFormulaFilter>())
      .subscribe({
        next: formulas => {
          this.formulaList = formulas.content;
          this.formulaList.forEach(rf => rf.lastUpdateDateString = (typeof rf.lastUpdateDate === 'number') ? this.dateTimeService.formatDateTime(rf.lastUpdateDate) : '');
          this.spinner.stop();
        },
        error: (error: HttpErrorResponse) => {
          console.error(error.message);
          this.spinner.stop();
        }
      });
  }

  formatTargetType(entityType: EntityType): string {
    return this.translateService.instant(
      `distribution.assessmentTypes.${entityType || 'ALL'}`
    );
  }

  formatStatus(status: RiskFormulaStatus): string {
    return this.translateService.instant(`formulaManagement.formulaStatus.${status}`);
  }

  onCreate(): void {
    this.createFormula.emit();
  }

  onFormulaSelected(): void {
    this.selectedFormulaChange.emit(this.selectedFormula);
  }

  onFormulaUnselected(): void {
    this.selectedFormulaChange.emit(null);
    this.formulaUnselected.emit();
  }

  onDeleteFormula(formula: RiskFormula): void {
    if (formula.defaultFormula) {
      return;
    }

    const DIALOG_REF = this.dialogService.open(
      ConfirmationModalComponent,
      {
        data: {
          body: this.translateService.instant('formulaManagement.formulaDeleteConfirmation')
        },
        header: this.translateService.instant('formulaManagement.deleteRiskFormula'),
        width: '35%'
      }
    );

    DIALOG_REF.onClose.pipe(
      filter(deleteFormula => deleteFormula),
      switchMap(() => this.agilityRiskService.deleteRiskFormula(formula.id))
    ).subscribe({
      next: () => {
        this.onFormulaUnselected();
        this.fetchRiskFormulas();

        this.messageService.success(
          this.translateService.instant('common.success'),
          this.translateService.instant('formulaManagement.deleteRiskFormulaSucess')
        );
      },
      error: (error: HttpErrorResponse) => {
        console.error(error.message);
        this.messageService.error(
          this.translateService.instant('common.error'),
          error.message
        );
      }
    });
  }

}
